import DatePicker from "@/components/DatePicker";
import SelectFinal from "@/components/input/Select";
import StaticDataSelect from "@/components/input/StaticDataSelect";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { handleFormChange } from "@/utils/formChange";
import { formInterface } from "@/interface/dataInterface";
import { FC, FormEvent } from "react";

const RefuelingForm: FC<formInterface> = ({ formProp, setFormProp, otherData, setOtherData }) => {
    return (
        <div className="w-full">
            <div className="w-full">
                <div className="grid grid-cols-2 gap-4">
                    <div className="grid gap-1">
                        <Label htmlFor="date" className="text-right">
                            Date *
                        </Label>
                        <DatePicker date={formProp.date} setDate={(e: FormEvent<any>) => handleFormChange(e, setFormProp)} />
                    </div>
                    <div className="grid gap-1">
                        <Label htmlFor="time" className="text-right">
                            Time *
                        </Label>
                        <Input type="time" id="time" value={formProp.time} onChange={(e: FormEvent<HTMLInputElement>) => handleFormChange(e, setFormProp)} required />
                    </div>
                </div>
                <div className="grid grid-cols-2 gap-4 mt-5">
                    <div className="grid gap-1">
                        <div className="w-full">
                            <Label htmlFor="vehicle_id" className="text-right">
                                Select vehicle
                            </Label>
                            <SelectFinal id="vehicle_id" value={formProp.vehicle_id} setValue={(e: FormEvent<HTMLSelectElement>) => handleFormChange(e, setFormProp)} resource="vehicles" dataProp="nickname" />
                        </div>
                    </div>
                    <div className="grid gap-1">
                        <Label htmlFor="odometer" className="text-right">
                            Odometer *
                        </Label>
                        <Input
                            min={0.1}
                            step={0.1}
                            id="odometer"
                            type="number"
                            value={formProp.odometer}
                            placeholder="Odometer" onChange={(e: FormEvent<HTMLInputElement>) => handleFormChange(e, setFormProp)}
                        />
                    </div>
                </div>
                <div className="grid gap-4 mt-5">
                    <div className="grid gap-1">
                        <Label htmlFor="value" className="text-right">
                            Filling tanks *
                        </Label>
                        <StaticDataSelect
                            id="type"
                            value={formProp.type}
                            setValue={(e: FormEvent<HTMLSelectElement>) => handleFormChange(e, setFormProp)}
                            data={[{label: 'primary'}, {label: 'secondary'}, {label: "both"}]}
                        />
                    </div>
                </div>
                {formProp.type !== "secondary" && <div className="grid gap-4 mt-5">
                    <div className="grid gap-1">
                        <Label className="text-right">
                            Primary tank *
                        </Label>
                        <div className="grid grid-cols-2 gap-4">
                            <Input required className="w-full" type="number" id="price_primary" placeholder="Price($)" value={otherData?.price_primary} onChange={(e: FormEvent<HTMLInputElement>) => handleFormChange(e, setOtherData || function() {})} />
                            <Input required className="w-full" type="number" id="liters_primary" placeholder="Liters" value={otherData?.liters_primary} onChange={(e: FormEvent<HTMLInputElement>) => handleFormChange(e, setOtherData || function() {})} />
                        </div>
                    </div>
                </div>}
                {formProp.type !== "primary" && <div className="grid gap-4 mt-5">
                    <div className="grid gap-1">
                        <Label htmlFor="value" className="text-right">
                            Secondary tank *
                        </Label>
                        <div className="grid grid-cols-2 gap-4">
                            <Input required className="w-full" type="number" id="price_secondary" placeholder="Price($)" value={otherData?.price_secondary} onChange={(e: FormEvent<HTMLInputElement>) => handleFormChange(e, setOtherData || function() {})} />
                            <Input required className="w-full" type="number" id="liters_secondary" placeholder="Liters" value={otherData?.liters_secondary} onChange={(e: FormEvent<HTMLInputElement>) => handleFormChange(e, setOtherData || function() {})} />
                        </div>
                    </div>
                </div>}
                <div className="grid mt-5">
                    <div className="grid gap-1">
                        <Label htmlFor="notes" className="text-right">
                            Notes *
                        </Label>
                        <div className="relative">
                            <Textarea id="notes" value={formProp.notes} onChange={(e: FormEvent<HTMLTextAreaElement>) => handleFormChange(e, setFormProp)} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RefuelingForm;